/* PRFORM PDP: gallery, size/variant choice, the kit, the sticky pill.
   Reveal (.rv) is handled globally in prform-v4.js. */
(function(){
  var root=document.querySelector('.pf4pdp-buy'); if(!root) return;
  var $=function(s,c){ return (c||root).querySelector(s); }, $$=function(s,c){ return [].slice.call((c||root).querySelectorAll(s)); };

  /* ---- gallery: click a tile and it becomes the main frame ---- */
  var gal=$('.gal'), main=$('#galMain'), count=$('.gal__count'), ctrN=$('.gal__ctrn');
  if(gal && main){
    var mainTile=main.parentElement, tiles=$$('.gal__tile',gal), n=tiles.length;
    var dots=$$('.gal__dots i'), small=matchMedia('(max-width:59.9375em)');
    gal.addEventListener('scroll',function(){
      if(!small.matches) return;
      var w=tiles[0].offsetWidth+8, i=Math.min(n-1,Math.max(0,Math.round(gal.scrollLeft/w)));
      dots.forEach(function(d,k){ d.classList.toggle('is-on',k===i); });
      if(ctrN) ctrN.textContent=(i+1)+' / '+n;
    },{passive:true});
    tiles.forEach(function(t,i){ t.addEventListener('click',function(){
      if(t===mainTile || small.matches || gal.classList.contains('gal--product')) return;
      var img=t.querySelector('img'); if(!img) return;
      var src=img.getAttribute('src'), cut=t.getAttribute('data-cut');
      var was=main.getAttribute('src'), wasCut=mainTile.getAttribute('data-cut');
      main.src=src; mainTile.classList.toggle('gal__tile--cut',!!cut);
      if(cut) mainTile.setAttribute('data-cut','1'); else mainTile.removeAttribute('data-cut');
      img.src=was; t.classList.toggle('gal__tile--cut',!!wasCut);
      if(wasCut) t.setAttribute('data-cut','1'); else t.removeAttribute('data-cut');
      if(count) count.textContent=(i+1)+' / '+n;
    }); });
  }

  /* ---- price, size, the kit ----
     Every price is formatted server side and carried on the size buttons,
     so nothing here has to know about money formats or currencies. */
  var form=$('.buyform'), idInput=$('.buyform input[name="id"]'), cta=$('.js-cta');
  var priceEl=$('.box__amount'), wasEl=$('.box__was'), tagEl=$('.box__pricetag');
  var kitRow=$('.plan__kit'), zipRow=$('.size--zip'), sizeLabel=$('.js-sizelabel');
  var stick=document.querySelector('.stick'), stickT=document.querySelector('.stick__t strong'), stickS=document.querySelector('.stick__t span');
  var kitId=root.getAttribute('data-kit-id')||'';
  var plan='solo', btn=null, kitVariant=kitId;

  function paint(){
    if(!btn) return;
    var kit = plan==='kit' && kitId;
    var d=btn.dataset, price = kit ? d.kitStr : d.soloStr, available = d.available==='true';
    if(priceEl) priceEl.textContent=price;
    if(wasEl){ var showWas = kit && d.kitWasStr && d.kitWasStr!==d.kitStr; wasEl.hidden=!showWas; if(showWas) wasEl.textContent=d.kitWasStr; }
    if(tagEl && tagEl.dataset.kit) tagEl.textContent = kit ? tagEl.dataset.kit : tagEl.dataset.solo;
    if(zipRow) zipRow.hidden=!kit;
    if(kitRow) kitRow.hidden=!kit;
    if(sizeLabel) sizeLabel.textContent = kit ? sizeLabel.dataset.kit : sizeLabel.dataset.solo;
    if(cta){
      cta.textContent = available ? (kit ? cta.dataset.kit : cta.dataset.solo)+' \u00b7 '+price : cta.dataset.sold;
      cta.disabled = !available;
    }
    if(idInput) idInput.value=d.variant;
    if(stickT) stickT.textContent = (kit ? stickT.dataset.kit : stickT.dataset.solo) + ' \u00b7 ' + d.title;
    if(stickS) stickS.textContent = price + ' \u00b7 ' + (stickS.dataset.ship||'');
  }

  $$('.size__btn[data-variant]').forEach(function(b){
    b.addEventListener('click',function(){
      var row=b.parentElement;
      $$('.size__btn',row).forEach(function(x){ x.classList.remove('is-on'); });
      b.classList.add('is-on');
      if(row.closest('.size--zip')) kitVariant=b.dataset.variant; else btn=b;
      paint();
    });
  });
  $$('.plan input').forEach(function(r){ r.addEventListener('change',function(){
    plan=r.value;
    $$('.plan__opt').forEach(function(o){ o.classList.toggle('is-on', o.contains(r)); });
    paint();
  }); });

  /* the kit is two line items; the discount, if there is one, lives in admin */
  if(form) form.addEventListener('submit',function(ev){
    if(plan!=='kit' || !kitId) return;
    ev.preventDefault();
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:[{id:btn.dataset.variant,quantity:1},{id:kitVariant||kitId,quantity:1}]})})
      .then(function(){ window.location='/cart'; })
      .catch(function(){ form.submit(); });
  });

  /* ---- sticky pill ---- */
  if(stick && cta){
    var past=false, atEnd=false;
    var upd=function(){ stick.classList.toggle('is-on', past && !atEnd); stick.setAttribute('aria-hidden', past && !atEnd ? 'false':'true'); };
    new IntersectionObserver(function(es){ es.forEach(function(e){ past = !e.isIntersecting && e.boundingClientRect.top<0; }); upd(); },{threshold:0}).observe(cta);
    var foot=document.querySelector('.pf4-footer, .ftr');
    if(foot) new IntersectionObserver(function(es){ es.forEach(function(e){ atEnd=e.isIntersecting; }); upd(); },{threshold:0}).observe(foot);
  }

  /* first variant wins */
  var first=$('.size__btn.is-on[data-variant]') || $('.size__btn[data-variant]');
  if(first) first.click();
})();
